import { createContext } from "react";

const CartItemsContext = createContext();

export default CartItemsContext;
